<template>
    <div class="root">
        <label class="col-sm-12">
            Telefone
            <a @click.prevent="showform=true;focus()" v-if="showform==false" class="glyphicon glyphicon-plus" ></a>
            <small v-if="showform==true" class="text-primary"><b>Pressione ESC para sair</b></small>
        </label>
        <div v-if="showform" @keyup.enter="add()" @keyup.esc="reset()" class="col-sm-12 form">
            <div class="col-sm-5">
                <input type="text" v-model="iptNumero" @keyup="maskTelefoneInput($event)" @focusout="maskTelefoneInput($event)" ref="iptnumero" placeholder="Número Telefone" class="form-control">
            </div>
            <div class="col-sm-5">
                <input type="text" v-model="iptDescricao" placeholder="Contato" class="form-control">
            </div>
            <div class="col-sm-2">
                <button @click.prevent="add()" class="btn btn-primary">Adicionar</button>
            </div>
        </div>
        <div class="col-sm-12">
            <ul class="list-inline">
                <li v-for="(telefone,index) in telefones">
                    <span class="text-primary">{{maskTelefone(telefone.numero)}}</span><br/>
                    <small>...{{telefone.descricao}}</small>
                    <a class="glyphicon glyphicon-pencil" @click.prevent="update(index)"></a>
                    <a class="glyphicon glyphicon-remove" @click.prevent="remove(index)"></a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  import Mask from './Mask.js'
  export default {
    name: 'telefone',
    props: ['telefones'],
    data () {
      return {
        showform: false,
        iptNumero: '',
        iptDescricao: '',
        index: -1
      }
    },
    methods: {
      add () {
        const item = {'numero': this.iptNumero, 'descricao': this.iptDescricao}
        this.$emit('add', item, 'telefone', this.index)
        this.reset()
      },
      update (index) {
        let telefone = this.telefones[index]
        this.iptNumero = telefone.numero
        this.iptDescricao = telefone.descricao
        this.index = index
        this.showform = true
        this.focus()
      },
      remove (index) {
        this.$emit('remove', 'telefone', index)
      },
      maskTelefoneInput (e) {
        e.target.value = this.maskTelefone(e.target.value)
      },
      focus () {
        this.$nextTick(() => { this.$refs.iptnumero.focus() })
      },
      reset () {
        this.showform = false
        this.iptNumero = ''
        this.iptDescricao = ''
        this.index = -1
      }
    },
    created: function () {
      this.maskTelefone = Mask.telefone
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/CliFormTelefone.vue